module.exports = __webpack_public_path__ + "img/4R.00632d02.png";